import React from 'react';
import { Popover, Box, ListItem, ListItemText, Checkbox } from '@mui/material';

function InventoryDropDown({ openPopover, anchorEl, handleClose, theme, list, setSelectedAccount, selectedAccount }) {
  const handleSelection = (data) => {
    setSelectedAccount([data]);
    handleClose();
  };

  console.log(selectedAccount, 'selectedAccountselectedAccount');

  return (
    <Popover
      id="tree-popover"
      open={openPopover}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      sx={{
        marginTop: '10px',
        '& .MuiPaper-root': {
          maxHeight: '600px',
          overflow: 'auto',
        },
      }}
    >
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          background: '#fff',
          minWidth: '350px',
          backgroundColor: theme?.palette?.TmId?.id?.toString()?.includes('9') ? '#26282A' : '#f9f9fe',
        }}
      >
        <Box>
          {list &&
            list.length > 0 &&
            list.map((data) => {
              return (
                <ListItem
                  key={data.accountsid}
                  sx={{
                    cursor: 'pointer',
                    '&.MuiListItem-root': {
                      paddingTop: '0px',
                      paddingBottom: '0px',
                      alignItems: 'center',
                      overflow: 'hidden',
                      '&:hover': {
                        backgroundColor: '#bdb7b7',
                      },
                    },
                  }}
                  onClick={() => handleSelection(data)}
                  secondaryAction={
                    <Checkbox
                      sx={{
                        marginRight: '2px',
                      }}
                      edge="end"
                      checked={selectedAccount?.find((acc) => acc.accountsid === data.accountsid)?.accountsid ? true : false}
                    />
                  }
                >
                  <ListItemText
                    id={data.accountsid}
                    primary={data.accountname}
                    sx={{
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  />
                </ListItem>
              );
            })}
        </Box>
      </Box>
    </Popover>
  );
}

export default InventoryDropDown;
